import { checkLocalSavedData, displayTutorialHand } from "../levelManager"
import { displayIndicator } from "../levelManager"
import { destroyIndicator } from "../levelManager"
import { displayInstructions } from "../levelManager"
import { phaserOverlay } from "../planetBlocker";
export function showFeedingTray(cockpitScene, side) {
    cockpitScene.ambianceSound = cockpitScene.sound
        .add("put-away-tablet", {
            volume: 2.5,
            loop: false,
        })
        .play();

    cockpitScene.tabletButton.input.enabled = false;
    cockpitScene.tabletButton.setAlpha(0.5);
    //playUISound(cockpitScene, cockpitScene.soundManager, "Subtle click 1", 0.25);
    cockpitScene.cockpitSoundHandler("Subtle click 1")
    console.log("Start Feeding");

    cockpitScene.savedUserData = checkLocalSavedData();
    cockpitScene.savedLevel = cockpitScene.savedUserData?.userLevel || 0;
    cockpitScene.savedMiniLevel = cockpitScene.savedUserData?.userMiniLevel || 0;
    cockpitScene.currentPlanet = cockpitScene.savedUserData?.currentPlanet || 0;

    const prefix = side === "left" ? "L" : "R";
    const baseX = side === "left" ? cockpitScene.gameW : cockpitScene.gameW * 3;

    // Hide feed button and text, show tray
    cockpitScene[`${prefix}FeedMeButton`].setVisible(false);
    cockpitScene[`${prefix}FeedMeText`].setVisible(false);
    cockpitScene[`${prefix}FoodTray`].setVisible(true);

    // Enable input on food tray items
    cockpitScene[`${prefix}FoodTrayItems`].getChildren().forEach((item) => {
        item.input.enabled = true;
    });

    // Animate tray into position
    cockpitScene.tweens.add({
        targets: cockpitScene[`${prefix}FoodTray`],
        x: baseX + 30 * cockpitScene.scaleFactor,
        duration: 300,
        ease: "Cubic",
    });

    // Configure food items based on planet and mini level
    configureFoodItems(cockpitScene, prefix, side);

    // Animate food items
    cockpitScene.tweens.add({
        targets: cockpitScene[`${prefix}FoodTrayItems`].getChildren(),
        x: baseX + 50 * cockpitScene.scaleFactor,
        duration: 300,
        ease: "Cubic",
        onComplete: () => {
            cockpitScene[`${prefix}FoodTrayItems`].getChildren().forEach((item) => {
                item.setVisible(true);
            });

            // Show food indicator for specific conditions
            showFoodIndicator(cockpitScene, prefix, side);
        },
    });

    // Display instructions and handle indicators
    handleInstructionsAndIndicators(cockpitScene);
}

function configureFoodItems(cockpitScene, prefix, side) {
    const { currentPlanet, savedMiniLevel } = cockpitScene;

    // Food configuration lookup table
    const foodConfigs = {
        2: { // Planet 2
            8: {
                condition: side === "right",
                textures: ["food03_thumb", "food09_thumb", "food05_thumb", "food04_thumb"]
            },
            15: {
                condition: side === "left",
                textures: ["food05_thumb", "food03_thumb", "food04_thumb", "food02_thumb"]
            }
        },
        3: { // Planet 3
            3: {
                condition: true,
                textures: ["food010_thumb", "food09_thumb", "food06_thumb", "food07_thumb"]
            },
            13: {
                condition: true,
                textures: ["food06_thumb", "food07_thumb", "food010_thumb", "food08_thumb"]
            },
            20: {
                condition: true,
                textures: ["food08_thumb", "food010_thumb", "food09_thumb", "food06_thumb"]
            }
        }
    };

    const config = foodConfigs[currentPlanet]?.[savedMiniLevel];

    if (config && config.condition) {
        cockpitScene[`${prefix}FoodTrayItems`].getChildren().forEach((item, index) => {
            if (config.textures[index]) {
                item.setTexture(config.textures[index]);
                item.setAlpha(1);
            }
        });
    }
}

function showFoodIndicator(cockpitScene, prefix, side) {
    const { currentPlanet, savedMiniLevel } = cockpitScene;

    // Indicator configuration
    const indicatorConfigs = {
        1: { miniLevel: 2, itemName: "foodTrayItem_0", side: "left" }
        //2: { miniLevel: 2, itemName: "foodTrayItem_2", side: "left" }
    };

    const config = indicatorConfigs[currentPlanet];

    if (config && savedMiniLevel === config.miniLevel && side === config.side) {
        const targetItem = cockpitScene[`${prefix}FoodTrayItems`].getChildren()
            .find(item => item.name === config.itemName);


        if (targetItem) {
            cockpitScene.foodTargetRef = targetItem
            cockpitScene.time.delayedCall(150, () => {
                // displayIndicator(
                //     cockpitScene,
                //     targetItem.x - cockpitScene.gameW,
                //     targetItem.y,
                //     1,
                //     "foodIndicator"
                // );

                if (cockpitScene.feedOverlayRef) {
                    cockpitScene.feedOverlayRef.remove()
                }
                const overlay = phaserOverlay(cockpitScene)
                // overlay.setTargetByCoords(
                //     targetItem.x - cockpitScene.gameW - targetItem.width * cockpitScene.scaleFactor * 0.125,
                //     targetItem.y - targetItem.height * cockpitScene.scaleFactor * 0.125,
                //     targetItem.width * cockpitScene.scaleFactor * 0.25,
                //     targetItem.height * cockpitScene.scaleFactor * 0.25
                // )
                const cutouts = [
                    {
                        x: cockpitScene.radar.x - 475 * cockpitScene.scaleFactor,
                        y: cockpitScene.radar.y - 50 * cockpitScene.scaleFactor,
                        width: 160 * cockpitScene.scaleFactor,
                        height: 110 * cockpitScene.scaleFactor
                    },
                    {
                        x: targetItem.x - cockpitScene.gameW - targetItem.width * cockpitScene.scaleFactor * 0.125,
                        y: targetItem.y - targetItem.height * cockpitScene.scaleFactor * 0.125,
                        width: targetItem.width * cockpitScene.scaleFactor * 0.25,
                        height: targetItem.height * cockpitScene.scaleFactor * 0.25
                    }
                ]

                overlay.setMultipleCutouts(cutouts);

                displayTutorialHand(cockpitScene, {
                    xPos: (targetItem.x - cockpitScene.gameW) + 90 * cockpitScene.scaleFactor,
                    yPos: targetItem.y,
                    rotation: -90
                })

                overlay.setAboveOverlay([cockpitScene.tutorialHand, cockpitScene.instructionBgContainer, cockpitScene.instructionBgCenter, cockpitScene.instructionBgRight, cockpitScene.instructionText])

                cockpitScene.singleFoodOverlayRef = overlay
                cockpitScene.foodTargetItemRef = targetItem
            });
        }
    }
}

function handleInstructionsAndIndicators(cockpitScene) {
    const { currentPlanet, savedMiniLevel } = cockpitScene;

    // Levels that need indicator destruction
    const destroyIndicatorLevels = {
        2: [15, 20],
        3: [20] // Assuming planet 3 level 20 also needs indicator destruction
    };

    if (destroyIndicatorLevels[currentPlanet]?.includes(savedMiniLevel)) {
        destroyIndicator(cockpitScene);
    }

    // Levels that need instructions
    const instructionLevels = {
        1: [2, 8],
        2: [2, 8, 15, 20],
        3: [5, 13, 20] // Added planet 3 levels
    };

    if (instructionLevels[currentPlanet]?.includes(savedMiniLevel)) {
        displayInstructions(
            cockpitScene,
            "Press on the correct food item until every slot has been filled",
            12,
            450,
            60
        );
    }
}